<template>
  <div class="commandes__produits" v-if="ligneCommandeDispositif">
    <div class="commandes__ligne-dispositif">
      <div class="nomDispositif pdh-10px">
        <b-field class="obligatoire"
          :label="$t('detail.article.ligneCommandeDispositif.nomDispositif')">
          <b-input
            v-model="ligneCommandeDispositif.nomDispositif" />
        </b-field>
      </div>
      <parametre-autocomplete
        v-model="ligneCommandeDispositif.dispositifSupportId"
        :label="$t('detail.article.ligneCommandeDispositif.dispositifSupport')"
        :target="constantes.PARAMETRES_KEYS.dispositifSupport"
        class="support pdb-5px"
        expanded
      />
      <div class="typeDispositif pdl-10px pdb-5px">
        <parametre-autocomplete
          :label="$t('detail.article.ligneCommandeDispositif.typeDispositif')"
          v-model="ligneCommandeDispositif.dispositifTypeId"
          :target="constantes.PARAMETRES_KEYS.dispositifType"
          required
        />
      </div>
      <div class="format pdh-10px pdb-5px">
        <parametre-autocomplete
          :label="$t('detail.article.ligneCommandeDispositif.format')"
          v-model="ligneCommandeDispositif.materielFormatId"
          :target="constantes.PARAMETRES_KEYS.materielFormat"
          expanded
          required
        />
      </div>
      <div class="typeMateriel pdh-10px">
        <parametre-autocomplete
          :label="$t('detail.article.ligneCommandeDispositif.materielType')"
          v-model="ligneCommandeDispositif.materielTypeId"
          :target="constantes.PARAMETRES_KEYS.materielType"
          expanded
          required
        />
      </div>
      <div class="longueur">
        <b-field :label="$t('detail.article.ligneCommandeDispositif.longueur')">
          <input-currency
            v-model="ligneCommandeDispositif.longueur"
            isNumber="true"/>
        </b-field>
      </div>
      <div class="largeur pdl-10px">
        <b-field :label="$t('detail.article.ligneCommandeDispositif.largeur')">
          <input-currency
            v-model="ligneCommandeDispositif.largeur"
            isNumber="true"/>
        </b-field>
      </div>
      <div class="doubleFace pdl-10px">
        <div class="columns mg-0">
          <qd-switch
            class="mgt-25px column"
            v-model="ligneCommandeDispositif.isDoubleFace">
            <span class="label">
              {{ $t("detail.article.ligneCommandeDispositif.isDoubleFace") }}
            </span>
          </qd-switch>
          <qd-switch
            class="mgt-25px column"
            v-model="ligneCommandeDispositif.materielEclaire">
            <span class="label">
              {{ $t("detail.article.ligneCommandeDispositif.eclaire") }}
            </span>
          </qd-switch>
        </div>
      </div>
      <div class="nomenclature"
        v-if="ligneCommandeDispositif.nomenclatureTypeId && mountedEnd">
        <qd-json-form class="json-form-dcf"
          v-model="ligneCommandeDispositif.nomenclature"
          :schema="schema">
      </qd-json-form>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import inputCurrency from '@/components/general/inputCurrency';
import { REFERENCE_TYPE_TECHNIQUE } from '@/configuration/parametrage/nomenclatureTypeConf';
import qdJsonForm from '@/components/parametrage/nomenclature/qdJsonForm';
import messageErreur from '@/services/general/messageErreur';
import parametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    ligneCommandeDispositif: {
      type: Object,
      required: true,
    },
    theme: {
      type: String,
      default: '',
    },
  },
  components: {
    parametreAutocomplete,
    inputCurrency,
    qdJsonForm,
  },
  data() {
    return {
      mountedEnd: false,
      constantes: {
        PARAMETRES_KEYS,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    nomenclatureType() {
      return this.parametre(
        PARAMETRES_KEYS.nomenclatureType,
      ).filter(el => el.reference === REFERENCE_TYPE_TECHNIQUE
        && (el.actif || el.id === this.ligneCommandeDispositif.nomenclatureTypeId));
    },
    schema() {
      const find = this.nomenclatureType.find(el => el.id
        === this.ligneCommandeDispositif?.nomenclatureTypeId);
      if (!find) return {};
      return JSON.parse(find.schema);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
  },
  async mounted() {
    this.$set(this.ligneCommandeDispositif, 'nomDispositif', this.ligneCommandeDispositif.nomDispositif ?? this.theme);
    try {
      await this.loadParametres([
        PARAMETRES_KEYS.nomenclatureType,
      ]);
      this.mountedEnd = true;
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
